const supportSteps = {
  start: {
    title: "محصول",
    message: "سلام سوارکار عزیز! دنبال  چه محصولی هستی؟ ما مناسب ترین فروشنده رو به شما پیشنهاد میدیم.",
    options: [
      { label: "شلوار / لگ", next: "pants_gender" ,tag:"شلوار_سوارکاری"},
      { label: "زین", next: "saddle_condition" , tag:"زین"},
      { label: "کلاه", next: "helmet_type" , tag:"کلاه"},
      { label: "چکمه / نیم بوت", next: "boot_type" ,tag:"نیم_بوت"},
      { label: "گتر", next: "getr_use" ,tag:"گتر"},
      { label: "دستکش", next: "glove_use" ,tag:"دستکش_سوارکاری"},
      { label: "کت مسابقه", next: "suite_quality" ,tag:"کت_سوارکاری"},
      { label: " عرقگیر - پد زیر زین", next: "pade_type" ,tag:"عرقگیر"},
      { label: " تاندون بند - بانداژ", next: "bandaj_type" ,tag:"تاندون_بند"},
      { label: "کله گیر", next: "kalle_quality" ,tag:"کله_گیر"},
      { label: "دست جلو", next: "dastjolo_quality" ,tag:"دستجلو"},
      { label: "جل / نیم جل / جل توری", next: "jol_type" ,tag:"جل"},
      { label: "عینک", next: "done" ,tag:"عینک_سوارکاری"},
      { label: "تیشرت / بلوز", next: "shirt_type",tag:"تیشرت_سوارکاری" },
      { label: "جلیقه محافظ", next: "vest_type" ,tag:"جلیقه_ایمنی_سوارکاری"},
      { label: "روغن سم / روغن زین", next: "oil_type" ,tag:"روغن_سم"},
      { label: "دارو مگس", next: "insect_medicine_quality" ,tag:"دارو_مگس"},
      { label: "دارو انگل", next: "angal_medicine_quality" ,tag:"دارو_انگل"},
      { label: "کیف / کوله", next: "backpack_quality" ,tag:"کوله_پشتی"},
      { label: "کائولین / تنداکس", next: "caolin_type" ,tag:"کائولین"},
      { label: "وسایل تیمار", next: "timar_quality" ,tag:"تیمار"},
      { label: "عضله ساز / مفصل ساز/ پروتئینه / روغن امگا / پروبیوتیک", next: "powder_type" ,tag:"عضله_ساز"},
      { label: "توری صورت", next: "toori_quality" ,tag:"توری_صورت"},
      { label: "تنگ پرشی", next: "tang_quality" ,tag:"تنگ_پرشی"},
      { label: "بذار خودم توضیح بدم", next: "extra_info_input" },
    ],
  },
  // شلوار سوارکاری********************************
  pants_gender: {
    title: "کاربری",
    message: "شلوار زنانه یا مردانه؟",
    options: [
      { label: "زنانه", next: "pants_size" },
      { label: "مردانه", next: "pants_size" },
    ],
  },
  pants_size: {
    title: "سایز",
    message: "چه سایزی می‌خواید؟",
    options: [
      { label: "XS", next: "pants_origin" },
      { label: "S", next: "pants_origin" },
      { label: "M", next: "pants_origin" },
      { label: "L", next: "pants_origin" },
      { label: "XL", next: "pants_origin" },
      { label: "سایزم رو نمیدونم", next: "done" },
    ],
  },
  pants_origin: {
    title: "کیفیت",
    message: "شلوار ایرانی یا خارجی؟",
    options: [
      { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
  // زین*********************************************************
   saddle_condition: {
    title: "نو یا کارکرده",
    message: "زین نو میخواید یا کارکرده؟",
    options: [
      { label: "نو", next: "saddle_price_rate" },
      { label: "کارکرده", next: "saddle_price_rate" },
      { label: "فرقی نمیکنه", next: "saddle_price_rate" },
    ],
  },
  saddle_price_rate: {
    title: "رنج قیمت",
    message: "چه رنج قیمتی مدنظرتونه؟",
    options: [
      { label: "کمتر از  100 میلیون", next: "done" },
      { label: " بین 100 تا 200 میلیون", next: "done" },
      { label: "بالاتر از 200 میلیون", next: "done" },
      { label: "قیمتش مهم نیست", next: "done" },
    ],
  },

  


  // کلاه ******************************************:
  helmet_type: {
    title: "کاربری",
    message: "چه مدل کلاهی مدنظرته؟",
    options: [
      { label: "زنانه", next: "done" },
      { label: "مردانه", next: "done" },
      { label: "بچه گانه", next: "done" },
    ],
  },

  // نیم بوت*********************************************************
   boot_type: {
    title: "محصول",
    message: "چه محصولی میخواهی؟",
    options: [
      { label: "نیم بوت", next: "boot_use" },
      { label: "چکمه بلند", next: "boot_use" },
    ],
  },
  boot_use: {
    title: "کاربری",
    message: "مردانه یا زنانه؟",
    options: [
       { label: "مردانه", next: "boot_size_man" },
      { label: "زنانه", next: "boot_size_wooman" },
    ],
  },
   boot_size_wooman: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "36", next: "done" },
      { label: "37", next: "done" },
      { label: "38", next: "done" },
      { label: "39", next: "done" },
      { label: "40", next: "done" },
      { label: "41", next: "done" },
      { label: "سایزم رو نمیدونم", next: "done" },
    ],
  },
  boot_size_man: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "38", next: "done" },
      { label: "39", next: "done" },
      { label: "40", next: "done" },
      { label: "41", next: "done" },
      { label: "42", next: "done" },
      { label: "43", next: "done" },
      { label: "سایزم رو نمیدونم", next: "done" },
    ],
  },

   //گتر *********************************************************

  getr_use: {
    title: "کاربری",
    message: "مردانه یا زنانه؟",
    options: [
       { label: "مردانه", next: "getr_size" },
      { label: "زنانه", next: "getr_size" },
      { label: "بچه گانه", next: "getr_size" },
    ],
  },
   getr_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "XS", next: "done" },
      { label: "S", next: "done" },
      { label: "M", next: "done" },
      { label: "L", next: "done" },
      { label: "XL", next: "done" },
      { label: "XXL", next: "done" },
      { label: "سایزم رو نمیدونم", next: "done" },
    ],
  },

//دستکش *********************************************************

  glove_use: {
    title: "کاربری",
    message: "مردانه یا زنانه؟",
    options: [
       { label: "مردانه", next: "glove_size" },
      { label: "زنانه", next: "glove_size" },
      { label: "بچه گانه", next: "glove_size" },
    ],
  },
   glove_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "XS", next: "done" },
      { label: "S", next: "done" },
      { label: "M", next: "done" },
      { label: "L", next: "done" },
      { label: "XL", next: "done" },
      { label: "XXL", next: "done" },
      { label: "سایزم رو نمیدونم", next: "done" },
    ],
  },
  //کت مسابقه *********************************************************

  suite_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "suite_use" },
      { label: "خارجی", next: "suite_use" },
      { label: "فرقی نمیکنه", next: "suite_use" },
    ],
  },
  suite_use: {
    title: "کاربری",
    message: "مردانه یا زنانه؟",
    options: [
       { label: "مردانه", next: "suite_size" },
      { label: "زنانه", next: "suite_size" },
      { label: "بچه گانه", next: "suite_size" },
    ],
  },
   suite_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "XS", next: "done" },
      { label: "S", next: "done" },
      { label: "M", next: "done" },
      { label: "L", next: "done" },
      { label: "XL", next: "done" },
      { label: "XXL", next: "done" },
      { label: "سایزم رو نمیدونم", next: "done" },
    ],
  },
  //عرقگیر / پد زیر زین *********************************************************

  pade_type: {
    title: "محصول",
    message: "عرقگیر یا پد زیر زین؟",
    options: [
       { label: "عرقگیر", next: "pade_quality" },
      { label: "پد زیر زین", next: "pade_under_salle_type" },
    ],
  },
  pade_under_salle_type: {
    title: "جنس",
    message: "از چه جنسی باشه؟",
    options: [
       { label: "ژلی", next: "pade_quality" },
      { label: "فومی", next: "pade_quality" },
      { label: "مهم نیست", next: "pade_quality" },
    ],
  },

  pade_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
 //تاندون بند / بانداژ *********************************************************

  bandaj_type: {
    title: "محصول",
    message: "ست تانون بند میخوای یا پد و بانداژ؟",
    options: [
       { label: "تاندون بند", next: "bandaj_quality" },
      { label: "پد و بانداژ", next: "bandaj_use" },
    ],
  },
  bandaj_use: {
    title: "استفاده",
    message: "برای چه استفاده ای؟",
    options: [
       { label: "کار", next: "bandaj_quality" },
      { label: "استراحت", next: "bandaj_quality" },
      
    ],
  },

  bandaj_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
  //کله گیر *********************************************************

  kalle_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "kalle_size" },
      { label: "خارجی", next: "kalle_size" },
      { label: "فرقی نمیکنه", next: "kalle_size" },
    ],
  },
  kalle_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "کره تا 6 ماه ", next: "done" },
      { label: "کره تا 1 و نیم سالگی", next: "done" },
      { label: "کوچک", next: "done" },
      { label: "متوسط", next: "done" },
      { label: "بزرگ", next: "done" },
      { label: "خیلی بزرگ", next: "done" },
    ],
  },
    //دست جلو *********************************************************

  dastjolo_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "dastjolo_size" },
      { label: "خارجی", next: "dastjolo_size" },
      { label: "فرقی نمیکنه", next: "dastjolo_size" },
    ],
  },
  dastjolo_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "کره تا 6 ماه ", next: "done" },
      { label: "کره تا 1 و نیم سالگی", next: "done" },
      { label: "کوچک", next: "done" },
      { label: "متوسط", next: "done" },
      { label: "بزرگ", next: "done" },
      { label: "خیلی بزرگ", next: "done" },
    ],
  },

  //جل / نیم جل / جل توری *********************************************************

   jol_type: {
    title: "محصول",
    message: "کدومش رو میخوای؟",
    options: [
       { label: "جل", next: "jol_quality" },
      { label: "نیم جل", next: "jol_quality" },
      { label: "جل توری", next: "jol_quality" },
    ],
  },
  jol_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "jol_size" },
      { label: "خارجی", next: "jol_size" },
      { label: "فرقی نمیکنه", next: "jol_size" },
    ],
  },
  jol_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "کره تا 6 ماه ", next: "done" },
      { label: "کره تا 1 و نیم سالگی", next: "done" },
      { label: "کوچک", next: "done" },
      { label: "متوسط", next: "done" },
      { label: "بزرگ", next: "done" },
      { label: "خیلی بزرگ", next: "done" },
    ],
  },
  // تیشرت / بلوز*********************************************************
   shirt_type: {
    title: "محصول",
    message: "چه محصولی میخواهی؟",
    options: [
      { label: "تیشرت سوارکاری", next: "shirt_use" },
      { label: "بلوز سوارکاری", next: "shirt_use" },
    ],
  },
  shirt_use: {
    title: "کاربری",
    message: "مردانه یا زنانه؟",
    options: [
       { label: "مردانه", next: "shirt_quality" },
      { label: "زنانه", next: "shirt_quality" },
      { label: "بچه گانه", next: "shirt_quality" },
    ],
  },
   shirt_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "shirt_size" },
      { label: "خارجی", next: "shirt_size" },
      { label: "فرقی نمیکنه", next: "shirt_size" },
    ],
  },

  shirt_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "XS", next: "done" },
      { label: "S", next: "done" },
      { label: "M", next: "done" },
      { label: "L", next: "done" },
      { label: "XL", next: "done" },
      { label: "XXL", next: "done" },
      { label: "سایزم رو نمیدونم", next: "done" },
    ],
  },

// جلیقه محافظ*********************************************************
   vest_type: {
    title: "نوع",
    message: "چه نوعی؟",
    options: [
      { label: "معمولی", next: "vest_use" },
      { label: "ضامن دار", next: "vest_use" },
    ],
  },
  vest_use: {
    title: "کاربری",
    message: "مردانه یا زنانه؟",
    options: [
       { label: "مردانه", next: "vest_quality" },
      { label: "زنانه", next: "vest_quality" },
      { label: "بچه گانه", next: "vest_quality" },
    ],
  },
   vest_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "vest_size" },
      { label: "خارجی", next: "vest_size" },
      { label: "فرقی نمیکنه", next: "vest_size" },
    ],
  },

  vest_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "XS", next: "done" },
      { label: "S", next: "done" },
      { label: "M", next: "done" },
      { label: "L", next: "done" },
      { label: "XL", next: "done" },
      { label: "XXL", next: "done" },
      { label: "سایزم رو نمیدونم", next: "done" },
    ],
  },
   //روغن سم / روغن زین *********************************************************

   oil_type: {
    title: "محصول",
    message: "کدومش رو میخوای؟",
    options: [
       { label: "روغن سم", next: "oil_quality" },
      { label: "روغن زین", next: "oil_quality" },
      
    ],
  },
  oil_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
  //دارو مگس*********************************************************
  insect_medicine_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },

  //دارو انگل*********************************************************

  angal_medicine_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
  //کوله پشتی*********************************************************

  backpack_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
   //کائولین*********************************************************

   caolin_type: {
    title: "محصول",
    message: "تنداکس یا کائولین؟",
    options: [
       { label: "تنداکس", next: "caolin_quality" },
      { label: "کائولین", next: "caolin_quality" },
    ],
  },
  caolin_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
   //تیمار*********************************************************

  timar_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
 //عضله ساز / مفصل ساز/ پروتئینه / روغن امگا / پروبیوتیک*********************************************************
   powder_type: {
    title: "محصول",
    message: "کدام محصول؟",
    options: [
       { label: "عضله ساز", next: "powder_quality" },
      { label: "مفصل ساز", next: "powder_quality" },
      { label: "پروتئینه ساز", next: "powder_quality" },
      { label: "روغن امگا", next: "powder_quality" },
      { label: "پروبیوتیک", next: "powder_quality" },
    ],
  },
  powder_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
//توری صورت*********************************************************

  toori_quality: {
    title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "done" },
      { label: "خارجی", next: "done" },
      { label: "فرقی نمیکنه", next: "done" },
    ],
  },
//توری صورت*********************************************************
tang_quality: {
  title: "کیفیت",
    message: "ایرانی یا خارجی؟",
    options: [
       { label: "ایرانی", next: "tang_size" },
      { label: "خارجی", next: "tang_size" },
      { label: "فرقی نمیکنه", next: "tang_size" },
    ],
  },

  tang_size: {
    title: "سایز",
    message: "چه سایزی؟",
    options: [
       { label: "کوچک", next: "done" },
      { label: "متوسط", next: "done" },
      { label: "یزرگ", next: "done" },
      { label: "خیلی بزرگ", next: "done" },
      { label: "سایزش رو نمیدونم", next: "done" },
    ],
  },



  done: {
    
    message: "ممنون! آیا توضیح اضافه‌ای داری؟",
    options: [
      { label: "بله", next: "extra_info_input" },
      { label: "خیر", next: "final_message" },
    ],
  },
  extra_info_input: {
    message: "لطفاً توضیح اضافه رو در کادر پایین وارد کن و دکمه ارسال رو بزن.",
    options: [],
  },
  final_message: {
    message: 
    "فروشگاه های زیر محصول شما رو موجود دارن، روی هر کدومشون که کلیک کنی، میتونی از طریق واتساپ بهشون پیام بدی و مستقیماً خریدت رو انجام بدی .(میتونی برگردی و فروشگاه دیگه ای رو هم انتخاب کنی)"
     ,
    options: [ { label: "ارسال با واتساپ", next: "send_to_whatsapp" },],
  },


};

export default supportSteps;
